.bubble {
  --progress-height: 3rem;
  display: flex;
  gap: var(--mantine-spacing-xs);
  align-items: center;
  height: var(--progress-height);
  font-size: var(--mantine-font-size-sm);
  color: var(--mantine-color-dark-1);
  mix-blend-mode: screen;
  transform-origin: 0 50%;
}

.spinner {
  height: 100%;
  mix-blend-mode: screen;
}

.label {
  color: var(--mantine-color-dark-2);
}
